// src/setup-globals.js — must be the FIRST side-effect import in src/entry.js.
//
// Responsibility is intentionally narrow: expose React + ReactDOM on the
// `window` object so the existing JSX files (which reference `React` and
// `ReactDOM` as free identifiers, the UMD pattern) keep working without
// modification under the bundled IIFE.
//
// Do NOT add Supabase, business config, or feature wiring here. Supabase
// lives in src/supabase-config.js so the platform-aware split has a single
// home that's easy to audit before submission.

import React from 'react';
import * as ReactDOMAll from 'react-dom';
import { createRoot, hydrateRoot } from 'react-dom/client';

window.React = React;
window.ReactDOM = Object.assign({}, ReactDOMAll, { createRoot, hydrateRoot });
